import { first, get, isEmpty } from 'lodash'

import { getIsGO } from '../../../1stlog-ui/src/utils/getIsGO'

export function getInlineTrackingLink(
  barcode: string,
  trackingHash?: string,
  zip?: string,
  language = 'de',
): string | null {
  const isGO = getIsGO()

  if (!isGO) {
    return null
  }

  const trackingNextDomains: string[] =
    get(global, 'currentUser.tenant.trackingNextDomains') || []

  if (isEmpty(trackingNextDomains)) {
    return null
  }

  const trackingNextDomain = first(trackingNextDomains) as string

  return `https://${trackingNextDomain.replace(
    /\/$/,
    '',
  )}/tracking/${barcode}?flavor=bland&zip=${
    zip ? zip : ''
  }&language=${language}`

  // Old
  return `${trackingNextDomain.replace(
    /\/$/,
    '',
  )}/lookup/${trackingHash}/coli/${barcode}`
}
